/**
 * The Calendar sidebar's Create ▾ → Event: asks the open Calendar screen for a new event (Google Calendar's Create).
 * A request made before the screen mounts (the sidebar opened the calendar first) waits for it.
 */
let pending = false;
const listeners = new Set<() => void>();

export function requestNewEvent(): void {
  if (listeners.size === 0) pending = true;
  for (const l of Array.from(listeners)) l();
}

export function onNewEventRequest(listener: () => void): () => void {
  listeners.add(listener);
  if (pending) {
    pending = false;
    listener();
  }
  return () => {
    listeners.delete(listener);
  };
}
